import { SELECT_CLIENT } from "../../CONSTANTS";

export default function selectClient({ id, type }) {
  return {
    type: SELECT_CLIENT,
    payload: {
      id,
      type,
    },
  };
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/actions/clients/selectClient.js